<button type="button" [ngClass]="styles.btnSubmittedDetails" vbBtnSecondary [popover]="('ApprovalWorkflow_PendingApproval_Heading' | translate) + ' - ' + (submittedDateTime | vbDateTimeMedium)" [placement]="'bottom'" [containerClass]="styles.btnPopOver">
	{{ 'ApprovalWorkflow_SubmissionDetails' | translate }}
</button>
